import { loadAblePlayer } from 'ableplayer'

function onAblePlayerReady(element) {
  console.info('✅ Found Able Player elements are loaded')
  loadAblePlayer()
}

let ablePlayerWatcher = null // Keep reference globally

export default ({ app }) => {
  app.router.afterEach((to, from) => {
    // Only create the watcher if it's not already active
    if (ablePlayerWatcher) {
      console.info('Watcher already running, skipping...')
      return
    }

    console.info('Starting Able Player watcher...')
    ablePlayerWatcher = setInterval(() => {
      const ablePlayerElement = document.querySelector('[data-able-player]')

      if (ablePlayerElement) {
        // Element found — run callback and stop watching
        onAblePlayerReady(ablePlayerElement)

        clearInterval(ablePlayerWatcher)
        ablePlayerWatcher = null
        console.info('Watcher stopped.')
      }
    }, 1000) // Check every second
  })
}
